import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { SeoHead } from '@/components/system/SeoHead';
import { DEFAULT_SEO_ENTRY, type RouteSeoEntry, ROUTE_SEO_CONFIG } from '@/content/seo';

const matchEntry = (pathname: string): RouteSeoEntry => {
  for (const entry of ROUTE_SEO_CONFIG) {
    const doesMatch = matchPath(
      { path: entry.pattern, end: entry.exact ?? true, caseSensitive: false },
      pathname
    );

    if (doesMatch) {
      return entry;
    }
  }

  return DEFAULT_SEO_ENTRY;
};

export function RouteSeoManager() {
  const location = useLocation();

  const entry = useMemo(() => matchEntry(location.pathname), [location.pathname]);
  const merged = { ...DEFAULT_SEO_ENTRY, ...entry };

  return (
    <SeoHead
      title={merged.title}
      description={merged.description}
      image={merged.image}
      keywords={merged.keywords}
      noindex={merged.noindex}
      structuredData={merged.structuredData}
      ogType={merged.ogType}
    />
  );
}
